export const CONVERSATION_PIN_CHANGE_EVENT = 'wxbot:conversation-pin-change'

export type ConversationPinChangeDetail = {
    accountWxid: string
    conversationWxid: string
    pinned: boolean
    pinnedAt?: number
}
